module.exports = __webpack_public_path__ + "../assets/mobile-2.jpg";